export interface PriceTier {
    qty: number;
    price: number;
    price_canadian_dollar: number;
}

export const PRICE_TIERS: PriceTier[] = [];
